import { useParams } from "react-router-dom";

export const usePSetId = () => {
  const params = useParams();
  if(params.psetId) {
    return params.psetId;
  } 
  return null
}